import { createReducer, on } from '@ngrx/store';
import { loadInsurerParams, loadInsurerParamsFailure, loadInsurerParamsSuccess } from '../../insurer/state/insurer.actions';
import { loadContractSuccess, loadContractFailure, submitCardIdSuccess, submitCardIdFailure, submitCardId_S4Success, submitCardId } from '../../contract/state/contract.actions';

import {
	resetTransactionInfo, setCardScanBypassed, setHasActiveQuestionnaire, setInsurerDobType, setInsurerPhoneNumber, setInsurerWebLink,
	setSelectedInsurerSuccess, setSelectedLanguageSuccess,
	setShowScreenSaver, setCardIdShowPage, setStartMethod,setContractBlocked, setSelectedContract, setBirthdate, setContractHasLanguageSupported, setAdmissionDate, setAgreementChecked, setOverwritePreHospiConfirmed, setPrehospi, setSelectedProvince, setSelectedCity, setConfirmedSite, setSelectedSite, addAnswersSummary, removeAnswersSummary, setCardNumber, setCurrentAnswers, setCurrentQuestion, setMobileApp, setQuestionCompleted, setQuestionConfirmed, resetContract, resetQuestionnaire, resetCurrentCity, resetCurrentProvince, resetCurrentInsurer, setSelectedInsurerFailure, setStartupProcessDone, setCardIdInUrl,
	setLoginError
} from './transaction-info.actions';
import { submitAdmissionDateSuccess } from '../../admission-date/state/admission-date.action';
import { checkExistingPrehospiSuccess, createPrehospiSuccess, createPrehospiFailure, checkExistingPrehospiFailure, getMedicalFormSuccess, getMedicalFormFailure, getPrintLightSuccess, getPrintLightFailure } from '../../hospi/state/hospi.actions';
import { AnswersSummary } from '../../question/model/AnswersSummary';
import { jwtDecode } from 'jwt-decode';
import { loginWithCertificateSuccess } from '../../authentication/state/authentication.actions';
import { loadQuestionnaireSuccess, loadQuestionnaireFailure, validateAnswerSuccess, validateAnswerFailure } from '../../question/state/question.actions';
import { CityDto, ContractDto, ContractLanguageSupportedDto, HospitalizationDto, InsurerDto, ProvinceDto, QuestionAnswersDto, QuestionnaireApplicableRulesDto, QuestionnaireDto, RefLanguageDto, SiteDto } from 'src/app/api/models';

export const transactionInfoFeatureKey = 'transactionInfo';

export interface TransactionInfoState {
	showScreensaver: boolean;
	selectedLanguage: RefLanguageDto;
	cardScanBypassed: boolean;
	selectedInsurer: InsurerDto;
	insurerHasActiveQuestionnaire: boolean;
	selectedInsurerDobType: string;
	selectedInsurerPhoneNumber: string;
	selectedInsurerWebLink: string;
	selectedInsurerPhoneNumberLoaded: boolean;
	selectedInsurerWebLinkLoaded: boolean;
	selectedInsurerParamsLoaded: boolean;
	cardIdShowPage: boolean;
	selectedContract: ContractDto;
	cardId: string;
	birthdate: string;
	cardIdIsValid: boolean;
	dobIsValid: boolean;
	hasActiveQuestionnaire: boolean;
	contractHasLanguageSupported: ContractLanguageSupportedDto;
	preOverwriteHospiConfirmed: boolean;
	hospitalisation: HospitalizationDto;
	hospitalisationRegistered: boolean;
	hospitalizationRegisterError: string;
	medicalFormPDF: File;
	printLightPDF: File;
	agreementChecked: boolean;
	admissionDate: Date;
	selectedProvince: ProvinceDto;
	selectedCity: CityDto;
	selectedSite: SiteDto;
	confirmedSite: boolean;
	questionCompleted: boolean;
	questionConfirmed: boolean;
	questionnaire: QuestionnaireDto;
	currentQuestion: QuestionAnswersDto;
	currentAnswers: QuestionAnswersDto[];
	answersSummary: AnswersSummary[];
	answerLightInfo: QuestionnaireApplicableRulesDto;
	medicalFormPrintUsingPdf: boolean;
	defaultSiteId: number;
	defaultHospitalNo: number;
	kioskId: number;
	isMobileApp: boolean;
	startupProcessDone: boolean;
	cardIdInUrl: string;
	startMethod: string;
	loginError: string;
}

export const initialState: TransactionInfoState = {
	showScreensaver: undefined,
	selectedLanguage: undefined,
	cardScanBypassed: undefined,
	selectedInsurer: undefined,
	insurerHasActiveQuestionnaire: undefined,
	selectedInsurerDobType: undefined,
	selectedInsurerPhoneNumber: undefined,
	selectedInsurerWebLink: undefined,
	selectedInsurerPhoneNumberLoaded: undefined,
	selectedInsurerWebLinkLoaded: undefined,
	selectedInsurerParamsLoaded: undefined,
	cardIdShowPage: true,
	selectedContract: undefined,
	cardId: undefined,
	birthdate: undefined,
	cardIdIsValid: undefined,
	hasActiveQuestionnaire: undefined,
	dobIsValid: undefined,
	contractHasLanguageSupported: undefined,
	preOverwriteHospiConfirmed: undefined,
	hospitalisation: undefined,
	hospitalisationRegistered: undefined,
	hospitalizationRegisterError: undefined,
	medicalFormPDF: undefined,
	printLightPDF: undefined,
	agreementChecked: false,
	admissionDate: undefined,
	selectedProvince: undefined,
	selectedCity: undefined,
	selectedSite: undefined,
	confirmedSite: false,
	questionCompleted: false,
	questionConfirmed: false,
	questionnaire: undefined,
	currentQuestion: undefined,
	currentAnswers: undefined,
	answerLightInfo: undefined,
	answersSummary: [],
	medicalFormPrintUsingPdf: undefined,
	defaultSiteId: undefined,
	defaultHospitalNo: undefined,
	kioskId: undefined,
	isMobileApp: undefined,
	startupProcessDone: undefined,
	cardIdInUrl: undefined,
	startMethod: undefined,
	loginError: undefined,
};


export const transactionInfoReducer = createReducer(
	initialState,
	on(setShowScreenSaver, (state, { data }) => ({ ...state, showScreensaver: data, })),
	on(setStartMethod, (state, { data }) => ({ ...state, startMethod: data, })),
	on(setSelectedLanguageSuccess, (state, { data }) => ({ ...state, selectedLanguage: data })),
	on(setCardScanBypassed, (state, { data }) => ({ ...state, cardScanBypassed: data })),
	on(setSelectedInsurerSuccess, (state, { data }) => ({ ...state, selectedInsurer: data })),
	on(setSelectedInsurerFailure, (state, { error }) => ({ ...state, selectedInsurer: undefined })),
	on(setHasActiveQuestionnaire, (state, { data }) => ({ ...state, insurerHasActiveQuestionnaire: data })),
	on(loadInsurerParamsSuccess, (state) => ({ ...state, selectedInsurerParamsLoaded: true })),
	on(loadInsurerParams, loadInsurerParamsFailure, (state) => ({ ...state, selectedInsurerParamsLoaded: false })),
	on(setInsurerDobType, (state, { dobType }) => ({ ...state, selectedInsurerDobType: dobType })),
	on(setInsurerPhoneNumber, (state, { data }) => ({ ...state, selectedInsurerPhoneNumber: data, selectedInsurerPhoneNumberLoaded: true })),
	on(setInsurerWebLink, (state, { data }) => ({ ...state, selectedInsurerWebLink: data, selectedInsurerWebLinkLoaded: true })),
	on(setCardIdInUrl, (state, { data }) => ({ ...state, cardIdInUrl: data })),
	on(setCardIdShowPage, (state, { data }) => ({ ...state, cardIdShowPage: data })),
	on(loadContractSuccess, (state, { data }) => ({ ...state, selectedContract: data ?? undefined })),
	on(loadContractFailure, (state, { error }) => ({ ...state, contract: undefined })),
	on(setContractBlocked, (state, { data }) => ({ ...state, contractBlock: data, })),
	on(setSelectedContract, (state, { data }) => ({ ...state, selectedContract: data, })),
	on(setBirthdate, (state, { data }) => ({ ...state, birthdate: data, })),
	on(submitCardIdSuccess, (state, { cardid }) => ({ ...state, cardId: cardid, cardIdIsValid: true })),
	on(submitCardIdFailure, (state) => ({ ...state, cardid: undefined, cardIdIsValid: false })),
	on(submitCardId, (state) => ({ ...state, cardIdIsValid: undefined })),
	on(setContractHasLanguageSupported, (state) => ({ ...state, birthdate: undefined, })),
	on(setStartupProcessDone, (state, { data }) => ({ ...state, startupProcessDone: data })),
	on(checkExistingPrehospiSuccess, (state, { data }) => ({ ...state, hospitalisation: data, })),
	on(createPrehospiSuccess, (state, { data }) => ({ ...state, hospitalisation: data, hospitalisationRegistered: true, })),
	on(createPrehospiFailure, (state, { error }) => ({ ...state, hospitalisation: null, hospitalisationRegistered: false, hospitalizationRegisterError: error })),
	on(checkExistingPrehospiFailure, (state) => ({ ...state, hospitalisation: null, })),
	on(setOverwritePreHospiConfirmed, (state, { data }) => ({ ...state, preOverwriteHospiConfirmed: data, })),
	on(setPrehospi, (state, { data }) => ({ ...state, hospitalisation: data, })),
	on(getMedicalFormSuccess, (state, { data }) => ({ ...state, medicalFormPDF: data })),
	on(getMedicalFormFailure, (state) => ({ ...state, medicalFormPDF: undefined })),
	on(getPrintLightSuccess, (state, { data }) => ({ ...state, printLightPDF: data })),
	on(getPrintLightFailure, (state) => ({ ...state, printLightPDF: undefined })),

	on(setAgreementChecked, (state, { data }) => ({ ...state, agreementChecked: data, })),
	on(setAdmissionDate, (state, { data }) => ({ ...state, admissionDate: data, })),
	on(submitAdmissionDateSuccess, (state, { data }) => ({ ...state, admissionDate: data, })),
	on(setSelectedProvince, (state, { data }) => ({ ...state, selectedProvince: data })),
	on(setSelectedCity, (state, { data }) => ({ ...state, selectedCity: data })),
	on(setConfirmedSite, (state, { data }) => ({ ...state, confirmedSite: data })),
	on(setSelectedSite, (state, { data }) => ({ ...state, selectedSite: data })),

	on(loadQuestionnaireSuccess, (state, { data }) => ({ ...state, questionnaire: data })),
	on(loadQuestionnaireFailure, (state) => ({ ...state, questionnaire: undefined })),
	on(validateAnswerSuccess, (state, { data }) => ({ ...state, answerLightInfo: data })),
	on(validateAnswerFailure, (state) => ({ ...state, answerLightInfo: undefined })),
	on(setCurrentQuestion, (state, { data }) => ({ ...state, currentQuestion: data })),
	on(setCurrentAnswers, (state, { data }) => ({ ...state, currentAnswers: data })),
	on(setQuestionCompleted, (state, { data }) => ({ ...state, questionCompleted: data })),
	on(setQuestionConfirmed, (state, { data }) => ({ ...state, questionConfirmed: data })),
	on(addAnswersSummary, (state, { data }) => ({ ...state, answersSummary: [...state.answersSummary, data] })),
	on(removeAnswersSummary, (state,) => ({ ...state, answersSummary: state.answersSummary.slice(state.answersSummary.length - 1, 1) })),


	on(setMobileApp, (state, { data }) => ({ ...state, isMobileApp: data, })),
	on(setCardNumber, (state, { data }) => ({ ...state, cardId: data, })),
	on(loginWithCertificateSuccess, (state, { data }) => ({
		...state,
		defaultHospitalNo: jwtDecode(data.access_token)["hospitalNo"],
		defaultSiteId: jwtDecode(data.access_token)["defaultSiteId"],
		kioskId: parseInt(jwtDecode(data.access_token)["kioskId"]),
	})),

	on(resetTransactionInfo, () => initialState),
	on(resetContract, (state) => ({
		...state,
		contractBlock: undefined,
		selectedContract: undefined,
		cardId: undefined,
		birthdate: undefined,
		cardIdIsValid: undefined,
		hasActiveQuestionnaire: undefined,
		dobIsValid: undefined,
		contractHasLanguageSupported: undefined,
		cardIdShowPage: true
	})),
	on(resetQuestionnaire, (state) => ({
		...state,
		questionCompleted: false,
		questionConfirmed: false,
		questionnaire: undefined,
		currentQuestion: undefined,
		currentAnswers: undefined,
		answerLightInfo: undefined,
		answersSummary: [],
		medicalFormPrintUsingPdf: undefined,
	})),
	on(resetCurrentProvince, (state) => ({
		...state,
		selectedProvince: undefined,
	})),
	on(resetCurrentCity, (state) => ({
		...state,
		selectedCity: undefined
	})),
	on(resetCurrentInsurer, (state) => ({
		...state,
		selectedInsurer: undefined,
		insurerHasActiveQuestionnaire: undefined,
		selectedInsurerDobType: undefined,
		selectedInsurerPhoneNumber: undefined,
		selectedInsurerWebLink: undefined,
		selectedInsurerPhoneNumberLoaded: undefined,
		selectedInsurerWebLinkLoaded: undefined,
		selectedInsurerParamsLoaded: undefined
	})),
	on(submitCardId_S4Success, submitCardIdSuccess, (state) => ({
		...state,
		cardScanBypassed: true,
	})),
	on(setLoginError, (state, { data }) => ({
		...state,
		loginError: data,
	})),


);

